import {BaseContainerModel} from "../../../base-container.model";
import {
  bl_alg_cc_agent_ext_RowClass,
  bl_alg_cc_agent_hdr_RowClass,
  bl_alg_cc_agent_hdr_RowInterface
} from "../../../../dbschema";

export class AgentContainerModel extends BaseContainerModel {
  bl_alg_cc_agent_hdr: bl_alg_cc_agent_hdr_RowInterface = new bl_alg_cc_agent_hdr_RowClass();
  bl_alg_cc_agent_exts: bl_alg_cc_agent_ext_RowClass[] = [];
}
